import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import Settings from "./Settings";
import ChatData from "./Chat";
import Auth from "./Auth";
import PageTitle from "./PageTitle";
import Notification from "./Notification";
import MapSettings from "./MapSettings";

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    chatData: ChatData,
    notification: Notification,
    mapSettings: MapSettings,
    auth: Auth,
    pageTitle: PageTitle,
  });
